import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ 
  title, 
  description, 
  keywords = [], 
  image = '/cognidoor-logo.png',
  type = 'website',
  url = null,
  structuredData = null,
  noIndex = false
}) => {
  const fullTitle = title ? `${title} | CogniDoor` : 'CogniDoor – Your Edge for McKinsey Solve & Consulting Case Prep';
  const fullUrl = url ? `https://www.cognidoor.com${url}` : 'https://www.cognidoor.com';
  const fullImage = image.startsWith('http') ? image : `https://www.cognidoor.com${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords.length > 0 && <meta name="keywords" content={keywords.join(', ')} />}
      
      {/* Canonical URL - Always use www version for consistency */}
      <link rel="canonical" href={fullUrl.replace('https://cognidoor.com', 'https://www.cognidoor.com')} />
      
      {/* Robots meta tag */}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl.replace('https://cognidoor.com', 'https://www.cognidoor.com')} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content="CogniDoor" />

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO; 